import { terrainPlotsCoords } from './../../scenes/Graveyards/config';
import { Object3D } from 'three'
import Interactive from './Interactive'
import { GAME_OBJECTS } from './types'

export default class TerrainTile extends Interactive {
  constructor(obj: Object3D) {
    super(obj)
    this.types.push(GAME_OBJECTS.TILE)
  }

  isSelectable() {
    return false
  }

  canInteract() {
    return !terrainPlotsCoords.find(c => c.equals(this.coords))
  }
}
